import Settings from '../../../../../settings/Settings';

interface EntryConfig {
    id: number;
    isLocked: boolean;
    description: string;
}

const HEIGHT = 224;

const TITLE = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 70,
    TINT: 0xffffff,
    SHADOW: { X: 2, Y: 2, TINT: 0x000000, ALPHA: 0.5 },
};

const SYNOPSIS = {
    FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
    SIZE: 38,
    TINT: 0x000000,
    MAX_WIDTH: 560,
    LINE_SPACING: -20,
};

export default class Entry extends Phaser.GameObjects.Container {
    private config: EntryConfig;

    private bg!: Phaser.GameObjects.Image;
    private title!: Phaser.GameObjects.BitmapText;
    private lock?: Phaser.GameObjects.Image;
    private synopsis!: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene, x: number, y: number, config: EntryConfig) {
        super(scene, x, y);

        this.config = config;

        this.setupBG();
        this.setupTitle();
        this.setupLock();
        this.setupSynopsis();
    }

    static get HEIGHT() {
        return HEIGHT;
    }

    setupBG() {
        let frame = this.isLocked ? 'comic/chapter_locked_bg' : 'comic/chapter_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.bg.setOrigin(0.5, 0);
        this.add(this.bg);

        if (this.isLocked) return;

        this.bg.setInteractive({ useHandCursor: true });

        this.bg.on('pointerup', (pointer: Phaser.Input.Pointer) => {
            if (Math.abs(pointer.prevPosition.y - pointer.position.y) < 10) this.emit('click', this.id);
        });
    }


    setupTitle() {
        let x = 0;
        let y = 50;

        this.title = this.scene.add.bitmapText(x, y, TITLE.FONT, `${this.scene.cache.json.get('i18n')['chapter']} ${this.id}`, TITLE.SIZE);
        this.title.setOrigin(0.5);
        this.title.setTint(TITLE.TINT);
        this.title.setDropShadow(TITLE.SHADOW.X, TITLE.SHADOW.Y, TITLE.SHADOW.TINT, TITLE.SHADOW.ALPHA);
        this.add(this.title);
    }

    setupLock() {
        if (!this.isLocked) return;

        let x = 260;
        let y = 40;
        let frame = 'comic/icon_lock';

        this.lock = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.lock);
    }

    setupSynopsis() {
        let x = 0;
        let y = 80;

        this.synopsis = this.scene.add.bitmapText(x, y, SYNOPSIS.FONT, this.description, SYNOPSIS.SIZE, 1);
        this.synopsis.setTint(SYNOPSIS.TINT);
        this.synopsis.setMaxWidth(SYNOPSIS.MAX_WIDTH);
        this.synopsis.setOrigin(0.5, 0);
        this.synopsis.setLineSpacing(SYNOPSIS.LINE_SPACING);
        this.add(this.synopsis);
    }

    get id() {
        return this.config.id;
    }

    get isLocked() {
        return this.config.isLocked;
    }

    get description() {
        return this.config.description;
    }
}
